// extracted by mini-css-extract-plugin
export default {"divider":"qHCsGAFRfl8bN5DGzeED","title":"qXnj5kvgPuTE6Pk49ZbF","header":"m6VOjtEJFE5ebYpfHGXC","headerContent":"XxxMnhf3cpHoGIXEtRib"};